import { required, maxLength } from 'vuelidate/lib/validators'

const httpMethods = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^GET$/.test(value) || /^POST$/.test(value) || /^PUT$/.test(value) || /^DELETE$/.test(value)
}

const webhookFormat = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^fila$/.test(value) || /^acao$/.test(value) || /^operador$/.test(value) || /^clicktocall$/.test(value) || /^ami$/.test(value)
}

const validateType = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return (
    /^QueueCallerAbandon$/.test(value) ||
    /^AgentConnect$/.test(value) ||
    /^QueueCallerJoin$/.test(value) ||
    /^AgentCalled$/.test(value) ||
    /^AgentRingNoAnswer$/.test(value) ||
    /^AgentComplete$/.test(value) ||
    /^CallerComplete$/.test(value) ||
    /^pause$/.test(value) ||
    /^unpause$/.test(value) ||
    /^login$/.test(value) ||
    /^logout$/.test(value) 
  )
}

export const validateData = {
  form: {
    description: { required, maxLength: maxLength(30) },
    url: { required, maxLength: maxLength(200) },
    method: { required, httpMethods },
    format: { required, webhookFormat },
    tipo: { validateType },
  },
}

export const validateComputed = {
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.description.$dirty) return errors
    !this.$v.form.description.required && errors.push('Campo obrigatório.')
    !this.$v.form.description.maxLength && errors.push('Campo não pode conter mais de 30 caracteres.')
    return errors
  },
  urlErrors() {
    const errors = []
    if (!this.$v.form.url.$dirty) return errors
    !this.$v.form.url.required && errors.push('Campo obrigatório.')
    !this.$v.form.url.maxLength && errors.push('Campo não pode ter mais de 200 caracteres.')
    return errors
  },
  methodErrors() {
    const errors = []
    if (!this.$v.form.method.$dirty) return errors
    !this.$v.form.method.required && errors.push('Campo obrigatório.')
    !this.$v.form.method.httpMethods && errors.push('Selecione um método válido.')
    return errors
  },
  formatErrors() {
    const errors = []
    if (!this.$v.form.format.$dirty) return errors
    !this.$v.form.format.required && errors.push('Campo obrigatório.')
    !this.$v.form.format.webhookFormat && errors.push('Selecione um formato válido.')
    return errors
  },
  tipoErrors() {
    const errors = []
    if (!this.$v.form.tipo.$dirty) return errors
    !this.$v.form.tipo.validateType && errors.push('Selecione um formato válido.')
    return errors
  },
}
